import { ReactElement, ReactNode, isValidElement } from "react"
import { validateDisplayNameChild } from "../utils/validateDisplayNameChild"
import { TabsItemProps } from "./types"
import { deepFind } from "../utils/deepFind"

export const isTabItem = (component: ReactNode): component is ReactElement<TabsItemProps> => {
  return !!deepFind(component, el => {
    return isValidElement(el) && validateDisplayNameChild(el, "Tabs.Item")
  })
}
